import { CmpInvoiceKindEnum } from "../../../graphql/types";

export type CmpEventCardCheckoutRestriction = {
  destination: "sponsorshipSales" | "ticketSales";
  guidance: string;
  linkLabel: string;
};

export type CmpEventSalesRouteTarget = {
  eventId: string;
  invoiceNumber: string;
  sourceId: string;
};

type CmpEventSalesRouteInvoice = {
  eventId?: string | null;
  eventRegistrationId?: string | null;
  eventSponsorshipRequestId?: string | null;
  invoiceNumber?: string | null;
};

export const getCmpEventCardCheckoutRestriction = ({
  invoiceKind,
}: {
  chamberMemberId?: string | null;
  invoiceKind: CmpInvoiceKindEnum;
}): CmpEventCardCheckoutRestriction | null => {
  if (invoiceKind === CmpInvoiceKindEnum.EventRegistration) {
    return {
      destination: "ticketSales",
      // Sidebar labels: Events & Sponsorships > Manage Tickets.
      guidance:
        "Take payments for event tickets in Events & Sponsorships > Manage Tickets, so the attendee list and event totals stay correct.",
      linkLabel: "Go to Manage Tickets",
    };
  }

  if (invoiceKind === CmpInvoiceKindEnum.EventSponsorship) {
    return {
      destination: "sponsorshipSales",
      // Sidebar labels: Events & Sponsorships > Manage Sponsorship.
      guidance:
        "Take payments for event sponsorships in Events & Sponsorships > Manage Sponsorship, so the sponsor list and event totals stay correct.",
      linkLabel: "Go to Manage Sponsorship",
    };
  }

  return null;
};

export const getCmpEventSalesRouteSearch = ({
  destination,
  invoice,
}: {
  destination: CmpEventCardCheckoutRestriction["destination"];
  invoice?: CmpEventSalesRouteInvoice | null;
}): string => {
  const eventId = invoice?.eventId?.trim() || "";
  const invoiceNumber = invoice?.invoiceNumber?.trim() || "";
  const sourceId =
    (destination === "ticketSales"
      ? invoice?.eventRegistrationId
      : invoice?.eventSponsorshipRequestId
    )?.trim() || "";

  if (!eventId || !invoiceNumber || !sourceId) {
    return "";
  }

  const search = new URLSearchParams({
    focusEventId: eventId,
    focusInvoiceNumber: invoiceNumber,
    focusSourceId: sourceId,
  });

  return `?${search.toString()}`;
};

export const getCmpEventSalesRouteTarget = (
  search: string
): CmpEventSalesRouteTarget | null => {
  const parameters = new URLSearchParams(search);
  const eventId = parameters.get("focusEventId")?.trim() || "";
  const invoiceNumber = parameters.get("focusInvoiceNumber")?.trim() || "";
  const sourceId = parameters.get("focusSourceId")?.trim() || "";

  return eventId && invoiceNumber && sourceId
    ? { eventId, invoiceNumber, sourceId }
    : null;
};
